import { render, staticRenderFns } from "./invit.vue?vue&type=template&id=d2b06f4c&scoped=true&"
import script from "./invit.vue?vue&type=script&lang=js&"
export * from "./invit.vue?vue&type=script&lang=js&"
import style0 from "./invit.vue?vue&type=style&index=0&id=d2b06f4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b06f4c",
  null
  
)

export default component.exports